var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Power"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 3.00024V7.75024",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.0001 3.38966C11.9938 4.03639 12.7519 4.98692 13.1615 6.09958C13.571 7.21224 13.61 8.42744 13.2727 9.56408C12.9354 10.7007 12.2398 11.6979 11.2897 12.4071C10.3395 13.1162 9.18562 13.4994 7.99999 13.4994C6.81436 13.4994 5.66047 13.1162 4.7103 12.4071C3.76014 11.6979 3.06457 10.7007 2.72727 9.56406C2.38997 8.42742 2.42899 7.21221 2.83853 6.09956C3.24807 4.9869 4.00619 4.03638 4.9999 3.38965",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.a9b1bdc8031e84b14bf6d9c6a3888c05.svg";
export { ForwardRef as ReactComponent };